import z from "zod";

const ReadAloudAddonConfig = z.object({"language": z.string()});
const HighlightCloudConfigOptions = z.object({});
const BookmarkCloudConfigOptions = z.object({});
const ReadAloudThirdPartyConfigOptions = z.object({});
const CustomFontsConfigOptions = z.array(z.object({
    name: z.string(),
    defaults: z.object({
        fallback: z.string()
    }),
    fontFaces: z.array(z.object({
        family: z.string(),
        mediaType: z.string(),
        src: z.string()
    }))
}));

export const AddonConfigSchema = z.object({
  readaloud: ReadAloudAddonConfig,
  highlightCloud: HighlightCloudConfigOptions,
  bookmarkCloud: BookmarkCloudConfigOptions,
  readloudThirdparty: ReadAloudThirdPartyConfigOptions,
  customFonts: CustomFontsConfigOptions,
}).partial().optional();